<template>
  <div class="navigator">
    <div class="company">
      <template v-if="$route.path == '/recog'">

      </template>
      <template v-else-if="$route.path == '/index'">
        <img src="../assets/logo-w.png" class="logo mr" v-if="!tid || !tenantInfo.logo">
        <img class="logo mr" :src="`/m/p/a/timg/${tenantInfo.id}/${tenantInfo.logo.split('/')[0]}`" v-else-if="tenantInfo.logo">
      </template>
      <template v-else>
        <i class="mdi mdi-arrow-left back mr" style="cursor: pointer" @click="goBack"></i>
      </template>
      <template v-if="$store.state.navTitle">
        <div class="name">
          {{$store.state.navTitle}}
        </div>
      </template>
      <template v-else>
        <div class="name">
          安全教育云平台
        </div>
      </template>
    </div>
    <GlobalDialog
      ref="logoutDialog"
      v-on:enter="logout"
      showText="确定退出"
    />
    <div class="user-cont" style="cursor: pointer" @click="tapLogout" v-if="!ignoreLogout">
      退出
    </div>
  </div>
</template>

<script>
  import GlobalDialog from '@/components/GlobalDialog'
  import { mapState } from 'vuex'
  export default {
    name: "Navigator",
    data() {
      return {
        ignoreLogout: false
      }
    },
    components: {
      GlobalDialog
    },
    computed: {
      ...mapState([
        'tenantInfo',
      ]),
      tid() {
        return this.$url.getParams()._tid || this.$url.getParams().tid
      }
    },
    mounted() {
      if(s.match('_t=[3|4|5]')){
        console.log(111)
        this.ignoreLogout = true
      }
    },
    methods: {
      tapLogout() {
        this.$refs.logoutDialog.showDialog()
      },
      logout() {
        this.$axios.get('/m/logout')
          .then(resp => {
            localStorage.removeItem('__token_d')
            this.$store.commit('changeClazzId', '')
            this.$router.replace('/login')
            this.$toast('退出成功')
          })
      },
      goBack() {
        if(sessionStorage.getItem('needSignOut')) {
          /* 拦截签退 */
          alert('请先进行签退')
        } else {
          history.back()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .navigator {
    min-width: 800px;
    width: 100%;
    height: 64px;
    background: $primary;
    background: var(--primary);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    flex-shrink: 0;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
    .company {
      display: flex;
      align-items: center;
      color: #fff;
      .back {
        font-size: 36px;
        line-height: 1;
      }
      .logo {
        flex-shrink: 0;
        max-height: 40px;
      }
      .mr {
        margin-right: 15px;
      }
      .name {
        font-size: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .user-cont {
      color: #fff;
      flex-shrink: 0;
    }
  }

</style>